




























































































  import {
    RequeteSnackbar,
    TypesMessagesSnackbar,
  } from '@/commun/components/snackbars/requete-snackbar';
  import { EtatsDemande, TypesDemande } from '@/domain/models/demande';
  import Demande from '@/domain/models/demande';
  import Routes from '@/router/routes';
  import Vue from 'vue';
  import DemandeProgramme, {
    DemandeProgrammeTypeModification,
  } from '@/domain/models/demande-programme';
  import DemandeCours from '@/domain/models/demande-cours';
  import { Spinner } from '@/commun/components/spinner';

  export default Vue.extend({
    name: 'DemandesTableauActions',
    components: {
      Spinner,
    },
    props: {
      demande: {
        type: Object as () => Demande,
        required: true,
      },
    },
    data: () => ({
      dialogSupprimerOuvert: false,
      estDemandeAvecDocuments: false,
      suppressionEnCours: false,
    }),
    computed: {
      sigleCoursProgramme(): string | undefined {
        if (this.demande.typeDemande === TypesDemande.MODIFICATION_PROGRAMME) {
          return (this.demande as DemandeProgramme).codeProgramme;
        }
        return (this.demande as DemandeCours).sigleCours;
      },
      libelleSigleCoursProgramme(): string {
        if (this.demande.typeDemande === TypesDemande.MODIFICATION_PROGRAMME) {
          return this.$t('demande.suppression.programme').toString();
        }
        return this.$t('demande.suppression.sigle-cours').toString();
      },

      numeroCoursMajeureProgramme(): string | undefined {
        if (this.demande.typeDemande === TypesDemande.MODIFICATION_PROGRAMME) {
          if (this.estMajeureExistante) {
            return (this.demande as DemandeProgramme).codeMajeure;
          }
          return (this.demande as DemandeProgramme).titreMajeure;
        }
        return this.numeroSerieCours();
      },
      libelleNumeroCoursMajeureProgramme(): string {
        if (this.demande.typeDemande === TypesDemande.MODIFICATION_PROGRAMME) {
          if (this.estMajeureExistante) {
            return this.$t('demande.suppression.majeure').toString();
          } else {
            return this.$t('demande.suppression.titre-majeure').toString();
          }
        }
        return this.$t('demande.suppression.Numero-cours').toString();
      },

      estMajeureExistante(): boolean {
        return (
          (this.demande as DemandeProgramme).typeModification ===
          DemandeProgrammeTypeModification.MAJEURE_EXISTANTE
        );
      },

      afficherBoutonSupprimer(): boolean {
        return (
          this.demande.etatDemande === EtatsDemande.EN_REDACTION ||
          this.demande.etatDemande === EtatsDemande.EN_MODIFICATION
        );
      },
      afficherBoutonModifier(): boolean {
        return (
          this.demande.etatDemande === EtatsDemande.EN_REDACTION ||
          this.demande.etatDemande === EtatsDemande.EN_MODIFICATION
        );
      },
    },
    methods: {
      numeroSerieCours(): string | undefined {
        if ((this.demande as DemandeCours).numeroCours) {
          return (this.demande as DemandeCours).numeroCours;
        } else {
          return (this.demande as DemandeCours).serieCours;
        }
      },

      onClickConsulter(): void {
        this.$router.push({
          name: Routes.ConsulterDemande,
          params: {
            idDemande: this.demande.id,
          },
        });
      },
      onClickModifier(): void {
        this.$router.push({
          name: Routes.ModifierDemande,
          params: {
            idDemande: this.demande.id,
          },
        });
      },
      async onClickSupprimer(): Promise<void> {
        await this.$store.dispatch(
          'obtenirDemandeCouranteDocuments',
          this.demande.id
        );
        this.estDemandeAvecDocuments =
          this.$store.state.GestionOffreFormation.demandeCouranteDocuments
            .length > 0;

        this.dialogSupprimerOuvert = true;

        this.$nextTick(() => {
          this.focusBoutonSupprimer();
        });
      },
      focusBoutonSupprimer(): void {
        const boutonSupprimer = this.$refs[
          'demandes-tableau-actions--supprimer'
        ] as Vue;
        if (boutonSupprimer) {
          setTimeout(() => {
            (boutonSupprimer.$el as HTMLElement).focus();
          });
        }
      },
      onClickAnnulerSuppression(): void {
        this.dialogSupprimerOuvert = false;
      },
      async onConfirmerSuppression(): Promise<void> {
        this.suppressionEnCours = true;
        if (this.estDemandeAvecDocuments) {
          await this.$store.dispatch(
            'supprimerDemandeDocuments',
            this.$store.state.GestionOffreFormation.demandeCouranteDocuments
          );
        }
        await this.$store
          .dispatch('supprimerDemande', this.demande.id)
          .then(() => {
            this.$store.dispatch(
              'notifierUtilisateur',
              new RequeteSnackbar(
                this.$t('demande.suppression.succes').toString(),
                TypesMessagesSnackbar.Succes
              )
            );
          });
        this.suppressionEnCours = false;
      },
    },
  });
